import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Message, Icon, Cell } from 'zarm';
import { FormContext } from '@/store/context';
import './index.less';
import { BaseRemark } from '@/baseComponents';

function ErrorMsg({
  message
}) {
  if (!message) {
    return null;
  }

  const iconNode = /*#__PURE__*/React.createElement(Icon, {
    type: "info-round"
  });
  return /*#__PURE__*/React.createElement(Message, {
    theme: "danger",
    icon: iconNode
  }, message);
} // name 表单名称
// fieldOption { rules : [], isPremiumFactor: false, ...  }
// children 需要被统一管理的字段组件
// label, 字段标题
// description 在表单组件后面出现


const FormItem = ({
  name,
  isShow = true,
  fieldOption = {},
  children,
  label,
  description,
  noStyle = false,
  newline = false,
  remark = {}
}) => {
  const form = useContext(FormContext); // const [isInit, setIsI       nit] = useState(true);

  const {
    getFieldDecorator,
    getFieldError,
    setFieldsValue
  } = form;
  const errors = getFieldError(name);
  const errMsg = Array.isArray(errors) && errors[0];
  const value = useSelector(state => {
    return _.get(state.formValues, name);
  });

  const setValue = val => {
    setFieldsValue({
      [`${name}`]: val
    });
  };

  const {
    isBenefitFactor,
    isPremiumFactor,
    initialValue
  } = fieldOption;

  const _rules = Array.isArray(fieldOption.rules) ? fieldOption.rules.slice() : [];

  if (isPremiumFactor || isBenefitFactor) {
    _rules.push({
      required: true,
      message: '请输入'
    });
  }

  if (noStyle) {
    return getFieldDecorator([name], _objectSpread(_objectSpread({}, fieldOption), {}, {
      rules: _rules
    }))(children);
  }

  useEffect(() => {
    if (value) {
      setValue(value);
    } else if ((fieldOption === null || fieldOption === void 0 ? void 0 : fieldOption.initialValue) !== undefined && (fieldOption === null || fieldOption === void 0 ? void 0 : fieldOption.initialValue) !== null) {
      setValue(fieldOption === null || fieldOption === void 0 ? void 0 : fieldOption.initialValue);
    } else {
      setValue();
    }
  }, [value]);
  useEffect(() => {
    setTimeout(() => {
      if (!value && initialValue) {
        setValue(initialValue);
      }
    }, 100);
  }, [initialValue]);
  let title = label;

  if (typeof label === 'string') {
    title = /*#__PURE__*/React.createElement(BaseRemark, {
      label: label,
      remark: remark
    });
  }

  return isShow ? /*#__PURE__*/React.createElement("div", {
    style: {
      height: !isShow ? 0 : 'auto'
    },
    "data-isBenefitFactor": isBenefitFactor,
    "data-formKey": name,
    "data-isPremiumFactor": isPremiumFactor
  }, /*#__PURE__*/React.createElement("div", {
    className: newline ? 'form-item newline' : 'form-item'
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-item-label"
  }, /*#__PURE__*/React.createElement(Cell, {
    title: title,
    description: description
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-item-control"
  }, getFieldDecorator([name], _objectSpread(_objectSpread({}, fieldOption), {}, {
    rules: _rules
  }))(children))))), /*#__PURE__*/React.createElement("div", {
    className: "form-item-explain-error"
  }, /*#__PURE__*/React.createElement(ErrorMsg, {
    message: errMsg
  }))) : null;
};

export default FormItem;